import styles from "./News.module.css";
import BasicPage from "../../components/BasicPage/BasicPage";
import PagedSection from "../../components/PagedSection/PagedSection";
import { useContext, useEffect, useMemo, useState } from "react";
import { PostContext } from "../../components/PostProvider/PostProvider";
import HorizontalPostLink from "../../components/HorizontalPostLink/HorizontalPostLink";
import ArrowSubtitle from "../../components/ArrowSubtitle/ArrowSubtitle";
import usePageTitle from "../../hooks/usePageTitle";
import NewsSearchBar from "../../components/NewsSearchBar/NewsSearchBar";
import NewsFeaturedHero from "../../components/NewsFeaturedHero/NewsFeaturedHero";
import CategoryChip from "../../components/CategoryChip/CategoryChip";
import FocusCover from "../../components/FocusCover/FocusCover";

function News() {
    const { cache, totalPosts, getPosts, featuredPosts, searchableData } =
        useContext(PostContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const currentPageStartIndex = useMemo(
        () => (currentPage - 1) * perPage,
        [currentPage, perPage]
    );

    const [searchBarState, setSearchBarState] = useState(false);

    usePageTitle("News");

    useEffect(() => {
        getPosts(currentPage, perPage, setLoading);
    }, [currentPage, perPage, getPosts]);

    return (
        <BasicPage>
            <FocusCover
                state={searchBarState}
                setState={setSearchBarState}
                background={true}
            />
            <div id={styles.heading}>
                <ArrowSubtitle dark={true} text={"News"} />
                <h1 className="main-h1">
                    Welcome to the <br />
                    Keel Mind News Room
                </h1>
            </div>
            <div className={styles.list_container}>
                <NewsFeaturedHero featuredPosts={featuredPosts} />
            </div>
            <div id={styles.filters_container}>
                <div
                    className={[
                        styles.categories_container,
                        "hide-scrollbar",
                    ].join(" ")}
                >
                    {loading ? (
                        <CategoryChip large={true} placeholder={true} />
                    ) : (
                        searchableData
                            .filter((r) => r.type === "category")
                            .map((cat) => (
                                <CategoryChip
                                    key={cat.id}
                                    large={true}
                                    {...cat}
                                />
                            ))
                    )}
                </div>
                {featuredPosts?.length > 0 && (
                    <NewsSearchBar
                        searchBarState={searchBarState}
                        setSearchBarState={setSearchBarState}
                        iconButton={true}
                    />
                )}
            </div>

            <div className={styles.list_container}>
                <h2>Latest</h2>
                <PagedSection
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    total={totalPosts}
                    className={[styles.links_container, "section-content"].join(
                        " "
                    )}
                >
                    {loading
                        ? Array(perPage)
                              .fill(0)
                              .map((_, index) => (
                                  <HorizontalPostLink
                                      key={index}
                                      placeholder={true}
                                  />
                              ))
                        : cache.orderedIds
                              .slice(
                                  currentPageStartIndex,
                                  currentPageStartIndex + perPage
                              )
                              .map((id) => {
                                  const post = cache.posts[id];
                                  return (
                                      <HorizontalPostLink
                                          key={id}
                                          post={post}
                                      />
                                  );
                              })}
                </PagedSection>
            </div>
        </BasicPage>
    );
}

export default News;
